import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

export type AlertType = 'success' | 'error' | 'warning' | 'info';

@Component({
  selector: 'app-alert',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.css',
})
export class AlertComponent {
  readonly type = input<AlertType>('info');
  readonly message = input.required<string>();
  readonly dismissible = input(true);
  readonly dismissed = output<void>();

  dismiss(): void {
    this.dismissed.emit();
  }
}
